export default __webpack_public_path__ + "static/media/juego27_exito.17746473.png";